import { render, staticRenderFns } from "./ClientEnvelopes.vue?vue&type=template&id=00ac42ce&scoped=true"
import script from "./ClientEnvelopes.vue?vue&type=script&lang=js"
export * from "./ClientEnvelopes.vue?vue&type=script&lang=js"
import style0 from "./ClientEnvelopes.vue?vue&type=style&index=0&id=00ac42ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac42ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
